'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var PropTypes = require('prop-types');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var JCBIcon = function JCBIcon(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'JCB' : _ref$title,
    props = _objectWithoutProperties__default.default(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsxs("svg", _objectSpread(_objectSpread({
    width: "24px",
    height: "14px",
    viewBox: "0 0 24 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    title: title,
    role: "img"
  }, props), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsx("title", {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsxs("defs", {
      children: [/*#__PURE__*/jsxRuntime.jsxs("linearGradient", {
        x1: "0%",
        y1: "50%",
        x2: "100%",
        y2: "50%",
        id: "linearGradient-1",
        children: [/*#__PURE__*/jsxRuntime.jsx("stop", {
          stopColor: "#313477",
          offset: "0%"
        }), /*#__PURE__*/jsxRuntime.jsx("stop", {
          stopColor: "#0077BC",
          offset: "100%"
        })]
      }), /*#__PURE__*/jsxRuntime.jsxs("linearGradient", {
        x1: "0%",
        y1: "50%",
        x2: "100%",
        y2: "50%",
        id: "linearGradient-2",
        children: [/*#__PURE__*/jsxRuntime.jsx("stop", {
          stopColor: "#753136",
          offset: "0%"
        }), /*#__PURE__*/jsxRuntime.jsx("stop", {
          stopColor: "#ED1746",
          offset: "100%"
        })]
      }), /*#__PURE__*/jsxRuntime.jsxs("linearGradient", {
        x1: "-0%",
        y1: "50%",
        x2: "100%",
        y2: "50%",
        id: "linearGradient-3",
        children: [/*#__PURE__*/jsxRuntime.jsx("stop", {
          stopColor: "#008049",
          offset: "0%"
        }), /*#__PURE__*/jsxRuntime.jsx("stop", {
          stopColor: "#62BA44",
          offset: "100%"
        })]
      }), /*#__PURE__*/jsxRuntime.jsxs("linearGradient", {
        x1: "0%",
        y1: "50%",
        x2: "100%",
        y2: "50%",
        id: "linearGradient-4",
        children: [/*#__PURE__*/jsxRuntime.jsx("stop", {
          stopColor: "#008049",
          offset: "0%"
        }), /*#__PURE__*/jsxRuntime.jsx("stop", {
          stopColor: "#62BA44",
          offset: "100%"
        })]
      }), /*#__PURE__*/jsxRuntime.jsxs("linearGradient", {
        x1: "0%",
        y1: "50%",
        x2: "100%",
        y2: "50%",
        id: "linearGradient-5",
        children: [/*#__PURE__*/jsxRuntime.jsx("stop", {
          stopColor: "#008049",
          offset: "0%"
        }), /*#__PURE__*/jsxRuntime.jsx("stop", {
          stopColor: "#62BA44",
          offset: "100%"
        })]
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M5.844,0.663 C4.77433333,0.663 3.79633333,1.62766667 3.79633333,2.71033333 L3.79633333,2.71033333 C3.79633333,3.306 3.79633333,5.66366667 3.79566667,8.00766667 L3.79566667,8.00766667 C3.99166667,8.13066667 4.93466667,8.43333333 5.31433333,8.46 L5.31433333,8.46 C6.145,8.519 6.66,8.244 6.73966667,7.55166667 L6.73966667,7.55166667 L6.73566667,4.98066667 L8.573,4.98066667 L8.573,7.493 C8.47666667,8.93233333 7.21366667,9.22533333 5.29233333,9.12833333 L5.29233333,9.12833333 C4.795,9.10333333 4.11866667,8.975 3.79533333,8.891 L3.79533333,8.891 C3.795,11.2366667 3.79433333,13.337 3.79433333,13.337 L3.79433333,13.337 L6.99233333,13.337 C7.865,13.337 9.001,12.5216667 9.001,11.2816667 L9.001,11.2816667 L9.001,0.663 L5.844,0.663 Z",
      fill: "url(#linearGradient-1)"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M11.7113333,0.663 C10.6413333,0.663 9.664,1.62766667 9.664,2.71033333 L9.664,2.71033333 C9.664,3.08766667 9.66366667,4.17233333 9.66333333,5.51266667 L9.66333333,5.51266667 C10.3053333,5.01133333 11.34,4.76533333 12.6566667,4.86666667 L12.6566667,4.86666667 C13.4056667,4.92466667 13.96,5.029 14.262,5.11866667 L14.262,5.11866667 L14.262,6.00766667 C13.929,5.842 13.2716667,5.594 12.7236667,5.555 L12.7236667,5.555 C11.482,5.46533333 10.8303333,6.047 10.8303333,6.988 L10.8303333,6.988 C10.8303333,7.83433333 11.3336667,8.559 12.7183333,8.462 L12.7183333,8.462 C13.1746667,8.43033333 13.935,8.16466667 14.258,8.01033333 L14.258,8.01033333 L14.262,8.87333333 C13.9836667,8.96133333 13.1176667,9.14966667 12.3026667,9.15633333 L12.3026667,9.15633333 C11.0756667,9.16633333 10.2103333,8.90566667 9.66266667,8.483 L9.66266667,8.483 C9.66233333,10.9873333 9.66166667,13.337 9.66166667,13.337 L9.66166667,13.337 L12.8596667,13.337 C13.7323333,13.337 14.8686667,12.5216667 14.8686667,11.2816667 L14.8686667,11.2816667 L14.8686667,0.663 L11.7113333,0.663 Z",
      fill: "url(#linearGradient-2)"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M16.5276667,7.25733333 L16.5256667,8.37733333 L17.778,8.381 C18.0213333,8.381 18.3276667,8.173 18.3276667,7.80966667 L18.3276667,7.80966667 C18.3276667,7.48833333 18.0633333,7.255 17.7796667,7.25766667 L17.7796667,7.25766667 C17.6046667,7.25933333 17.3263333,7.25866667 17.074,7.25766667 L17.074,7.25766667 C16.9196667,7.257 16.7753333,7.25666667 16.6706667,7.25666667 L16.6706667,7.25666667 C16.6046667,7.25666667 16.5543333,7.25666667 16.5276667,7.25733333",
      fill: "url(#linearGradient-3)"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M16.5233333,5.60533333 L16.5193333,6.62466667 L17.7023333,6.633 C17.8993333,6.629 18.1756667,6.44866667 18.1756667,6.13366667 L18.1756667,6.13366667 C18.1756667,5.81233333 17.934,5.59566667 17.6773333,5.60133333 L17.6773333,5.60133333 C17.5103333,5.60533333 17.2816667,5.60366667 17.07,5.60233333 L17.07,5.60233333 C16.956,5.60133333 16.8466667,5.60066667 16.7546667,5.60066667 L16.7546667,5.60066667 C16.648,5.60066667 16.5643333,5.60166667 16.5233333,5.60533333",
      fill: "url(#linearGradient-4)"
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M17.5513333,0.663 C16.4813333,0.663 15.504,1.62766667 15.504,2.71033333 L15.504,2.71033333 C15.504,3.03466667 15.504,3.88133333 15.5036667,4.96333333 L15.5036667,4.96333333 L18.5436667,4.96333333 C19.1483333,4.96333333 19.8606667,5.222 19.8606667,5.95733333 L19.8606667,5.95733333 C19.8606667,6.352 19.6506667,6.79866667 18.894,6.94366667 L18.894,6.94366667 L18.894,6.96033333 C19.336,6.96033333 20.102,7.219 20.102,7.99933333 L20.102,7.99933333 C20.102,8.805 19.2743333,9.02866667 18.831,9.02866667 L18.831,9.02866667 L15.5026667,9.032 C15.5023333,11.32 15.502,13.337 15.502,13.337 L15.502,13.337 L18.7,13.337 C19.5726667,13.337 20.7083333,12.5216667 20.7083333,11.2816667 L20.7083333,11.2816667 L20.7083333,0.663 L17.5513333,0.663 Z",
      fill: "url(#linearGradient-5)"
    })]
  }));
};
JCBIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "JCBIcon",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'JCB'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var JCBIcon$1 = JCBIcon;
JCBIcon.propTypes = {
  title: PropTypes__default.default.string
};

exports.default = JCBIcon$1;
//# sourceMappingURL=JCBIcon.js.map
